export default __webpack_public_path__ + "static/media/discardChanges.6549be5f.svg";